const CustomerAgreementType = {
  SET_CUSTOMER_AGREEMENT_DATA: 'SET_CUSTOMER_AGREEMENT_DATA',
  INITIALIZE_CUSTOMER_AGREEMENT_STATE: 'INITIALIZE_CUSTOMERAGREEMENT_STATE',
};

export default CustomerAgreementType;
